exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logo{max-width:100%;height:auto}.shortcutbar{width:60px;position:fixed;left:0;top:0;height:100vh;padding-top:0;background:linear-gradient(0deg,#2ba3cf,#22b6b4)}.shortcutbar-link{display:block;color:#fff;text-align:center;padding:14px 16px 10px}.shortcutbar-link.logo-link{padding:10px 16px 4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4b172778!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/navigation/Shortcutbar.vue
// module id = 472
// module chunks = 22